import React, { useState, useContext, useEffect } from "react";
import { useMutation } from '@apollo/react-hooks';
import _ from "lodash";
import "react-circular-progressbar/dist/styles.css";
import { Loading, Toast, Modal } from "@shopify/app-bridge-react";
import Axios from 'axios'
import removeTypeName, { removeByType } from 'lib/removeTypeName';

import { SAVE_SHOP_SETTINGS } from 'lib/mutations';
import EmbeddedContext from "context/EmbeddedContext";
import { Redirect } from "@shopify/app-bridge/actions";
import { GET_SHOP_SETTINGS } from 'Queries';
import styles from "styles/settings.module.scss";
import { API } from "aws-amplify";
import {
  Page,
  Alert,
  ButtonSelect,
  FormGroup,
  FormControl,
  CustomText,
  ColorPicker,
  Input,
  Dropdown
} from "components";
import classNames from "lib/classNames";
import { useTransition, animated } from "react-spring";
import UserContext from "context/UserContext";
import ShopContext from "context/ShopContext";
import {
  CHECKER_POSITION,
  OFFER_POSITION,
  CHECKER_TYPE,
} from "lib/globals";
import ProtectionIconSelector from './settings/ProtectionIconSelector'
import Preview from './preview'
import { APP_DEV } from "aws-exports";






const SettingsScreen = () => {
  const user = useContext(UserContext);

	const [hideTopBar, setHideTopBar] = useState(false);
	const [isAppActive, setIsAppActive] = useState(false);
	const [cartActivateLoading, setCartActivateLoading] = useState(false);
	const [openTooltip, setOpenTooltip] = useState(false);
  const [showInstallationModel, setShowInstallationModel] = useState(false);
  const shopContext = useContext(ShopContext);
  const {
    state,
    discard,
    setItem
  } = shopContext;
  
  const {
    // active, 
    priceStep,
    priceMin,
    pricing, 
    tooltip:{
      active: isTooltipActive
    }
  } = state.settings

const { app, AppBridgeRedirect } = useContext(EmbeddedContext);
  const protectActivate = async () => {
    setCartActivateLoading(true)
    check()
      setShowInstallationModel(true)
      setCartActivateLoading(false)
      return 
		// await API.post('API_GATEWAY_NEW', '/protect/activate', {
		// 	body: { active: false },
		// });
    // save({ active: false })
    setCartActivateLoading(false)
  }


	const transitions = useTransition(!_.isEqual(state.original_settings, state.settings) && !hideTopBar, null, {
		from: { position: 'absolute', opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
		config: {
			duration: 300,
		},
	});

  const openChat = () => {
    document.querySelector('.cc-imbb.cc-qfnu').click()
  }

  const setPriceStep = (step) => {
    console.log(step)
    setItem('settings.priceStep', step)
  }

  const filterSettings = (settings) => {
		return removeByType(
			removeTypeName(
				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
			),
			(v) => v !== '' && v !== null
		);
  }
  let [saveShopSettings, { data, error, loading }] = useMutation(SAVE_SHOP_SETTINGS, {
    refetchQueries: [
      {
        query: GET_SHOP_SETTINGS,
        variables: {
          userId: user.attributes.website,
        },
      },
    ],
  });

  
  const saveProduct = async () => {
    const {
      pricing:  {value: priceValue },
    } = state.settings

    if ( priceValue === "") return;
    try{
      await API.post("API_GATEWAY_NEW", "/products", {
        body: {
          fixed: priceValue,
          priceStep: priceStep,
          priceMin: priceMin
        }
      })
    }catch(e){
      console.log("ERROR updating product")
      console.log(e)
    }
  }
  
  const save = async (assign = {}) => {
    // console.log(state.settings)
    saveProduct()
    setCartActivateLoading(true)
		saveShopSettings({
			variables: {
				id: user.attributes.website,
				input: filterSettings(Object.assign(state.settings, assign)),
			},
		});
    setCartActivateLoading(false)
	};

  const check = async () =>{
    const {status} = await API.get("API_GATEWAY_NEW", "/store/check");
    setIsAppActive(status)
  }
  useEffect(() => {
    const interval = setInterval(check , 10000);
    return () => clearInterval(interval);
  },[])
  useEffect(() => {
    check()
  },[])
  
  return (
    <Page
      header={{
        title: "Settings",
        actions: [],
      }}
      loading={{
        text: "Loading",
        status: false,
      }}
      background="none"
      padding={0}
      TopContent={{
        transitions,
        render: ({  }) => (
          <Alert
            type="save_settings"
            title="unsaved changes"
            borderPosition="none"
            paddingX="px-6"
            actions={[
              {
                text: "Discard",
                type: "secondary",
                loading: false,
								onClick: () => discard(),
              },
              {
                text: "Save",
                type: "primary",
                // disabled: Object.keys(validationErrors).length,
								loading: loading || cartActivateLoading,
								onClick: () => save(),
              },
            ]}
          />
        ),
      }}
    >
      <div className={styles.page}>
        <div className={styles.settings}>
          <Alert
            type={isAppActive ? "success" : "warning"}
            icon={isAppActive ? "check-circle" : "exclamation-circle"}
            title={`ShipProtect is ${!isAppActive ? 'not activated on your theme': 'active on your theme'}` }
            className="z-5"
            actions={[
              {
                text: isAppActive ? "Disable" : "Activate",
                type: "primary",
                loading: cartActivateLoading,
								onClick: () =>  protectActivate(),
              }
            ]}
          >
            <p>
              {" "}
              This will automatically create or update this product in Shopify
              and add the offer widget to Cart
            </p>
          </Alert>
          <ProtectionIconSelector shopContext={shopContext} />
          <FormGroup>
            <FormControl>
              <CustomText
                context={shopContext}
                label="Product title"
                path="settings.title"
                hasColor={true}
                max={22}
                min={8}
              />
            </FormControl>
            <FormControl>
              <CustomText
                context={shopContext}
                label="Opt-in Message"
                path="settings.unselectedMessage"
                hasColor={true}
                max={22}
                min={8}
              />
            </FormControl>
            <FormControl>
              <CustomText
                context={shopContext}
                label="Opt-out Message"
                path="settings.selectedMessage"
                hasColor={true}
                max={22}
                min={8}
              />
            </FormControl>
            
            <FormControl>
             <ButtonSelect
                keyPrefix='price'
                options={[
                  { value: "percentage",  info: "Charge a percentage total cart value", label: "Percentage"  },
                  { value: "fixed_amount",  info: "Charge a fixed price", label: "Fixed" },
                ]}
                value={pricing.type}
                onChange={setPriceStep}    
                        
                BindToContext={[shopContext, `settings.pricing.type`]}
                className={classNames("mt-4")}
              />
            </FormControl>
            <FormControl label="Insurance Pricing">
              <Input
                type="number"
                min={0}
                BindToContext={[shopContext, `settings.pricing.value`]}
                icon={{char:pricing.type === 'fixed_amount'? "$": "%" }}
              />
            </FormControl>
             { pricing.type !== 'fixed_amount' ?
            <FormControl marginBottom='mb-2'>
              <FormControl label="Minimum Charge" marginBottom='mb-0'>
                <Input
                  icon={{char:"$" }}
                  type="number"
                  min={1}
                  BindToContext={[shopContext, `settings.priceMin`]}
                  disabled={pricing.type === 'fixed_amount'}
                />
                </FormControl>
              <FormControl label="Incriment Amounts" marginBottom='mb-0'>
                <Input
                  type="number"
                  icon={{char:"$" }}
                  min={1}
                  BindToContext={[shopContext, `settings.priceStep`]}
                  disabled={pricing.type === 'fixed_amount'}
                />
              </FormControl>
            </FormControl>
            :
            undefined
            }
            { pricing.type !== 'fixed_amount' ?
              <>
                <p	className={classNames("text-gray-500 text-xs italic")}>Customer will be charged in increments of ${priceStep} with a minimum charge of ${priceMin}. </p>
                <p	className={classNames("text-gray-500 text-xs italic mb-2")}>The insurance pricing will increase as the cart size increases with a maximum charge of ${priceMin + (priceStep * 98)}. Learn more  </p>
              </>
              :
              <p	className={classNames("text-gray-500 text-xs italic mb-2")}>Customer will be charged ${pricing.value}. </p>
            }
                
            <FormControl label="Accept offer style" >
                <Dropdown
                    options={CHECKER_TYPE}
                    first
                    BindToContext={[shopContext, "settings.checker_type"]}
                />
            </FormControl>
            <FormControl label="Accept offer position" >
                <Dropdown
                    options={CHECKER_POSITION}
                    first
                    BindToContext={[shopContext, "settings.checker_position"]}
                />
            </FormControl>
            <FormControl label="Widget position" >
                <Dropdown
                    options={OFFER_POSITION}
                    first
                    BindToContext={[shopContext, "settings.offer_position"]}
                />
            </FormControl>
            <FormControl label="Pre-Select offer" withSwitch={[shopContext, "settings.pre_select"]} marginBottom="mb-6">
            <></>
            </FormControl>
            <FormControl label="ToolTip" withSwitch={[shopContext, "settings.tooltip.active"]} marginBottom={isTooltipActive? "mb-2" : "mb-6"}>
              <></>
            </FormControl>
            {
              isTooltipActive ? ( <>
                  <FormControl>
                    <CustomText
                      context={shopContext}
                      label="Description on shopify product (Shown on ToolTip)"
                      path="settings.product_description"
                      hasColor={true}
                      min={8}
                      max={22}
                      onFocus={() =>setOpenTooltip(true)}
                      onBlur={() =>setOpenTooltip(false)}
                    />
                  </FormControl>
                  <FormControl>
                    <CustomText
                      context={shopContext}
                      label="T&Cs link (Shown on ToolTip)"
                      path="settings.tooltip.linkText"
                      withSwitch={[shopContext, 'settings.tooltip.withLink']}
                      hasColor={true}
                      min={8}
                      max={22}
                      onFocus={() =>setOpenTooltip(true)}
                      onBlur={() =>setOpenTooltip(false)}
                    />
                  </FormControl>
                  <FormControl label="T&Cs URL (Shown on ToolTip)">
                    <Input
                      BindToContext={[shopContext, "settings.tooltip.link"]}
                      indicator="https://google.com"
                      onFocus={() =>setOpenTooltip(true)}
                      onBlur={() =>setOpenTooltip(false)}
                    />  
                  </FormControl>
                  
                  <FormControl>
                    <ColorPicker
                      text="background"
                      BindToContext={[
                        shopContext,
                        "settings.tooltip.background"
                      ]}
                      onFocus={() =>setOpenTooltip(true)}
                      onBlur={() =>setOpenTooltip(false)}
                    />
                    <ColorPicker
                      text="symbol"
                      BindToContext={[
                        shopContext,
                        "settings.tooltip.symbol"
                      ]}
                      onFocus={() =>setOpenTooltip(true)}
                      onBlur={() =>setOpenTooltip(false)}
                    />
                  </FormControl>
                </>)
                : undefined
            }
            {/* <FormControl label="Hide Powered by SmartProtect" withSwitch={[shopContext, "settings.smartprotect"]}></FormControl> */}
          </FormGroup>
        </div>
        <div className={styles.preview}>
          <div className={styles.floating}>
          <Preview openTooltip={openTooltip}/>
          <div  className={styles.contactUs}>Remove "Powered by ShipProtect",{` `}<span onClick={openChat} className={styles.contactUsBtn}>Contact us</span></div>
          {/* <div className={classNames( "shadow text-gray-800 my-4 p-4 rounded-lg bg-white text-black " )}>
              <div  className={classNames( "pb-2 font-bold rounded-lg bg-white " )}>
                  Move placement on Cart Page
              </div>    
              <div  className={classNames( "text-md" )}>
                  You can activate the app embed options and moving widget to where you would like on the cart page.{` `}<span onClick={openChat} className={classNames( "pointer underline")}>Contact us</span>
              </div>          
          </div> */}
          <div className={classNames( "shadow text-gray-800 my-4 p-4 rounded-lg bg-white text-black " )}>
              <div  className={classNames( " pb-2 font-bold rounded-lg bg-white " )}>
                  Something not working?
              </div>    
              <div  className={classNames( "text-md" )}>
                  Simply  reach out to team. Happy to help 😄
              </div>          
          </div>
          </div>
        </div>

        <Modal
          size="Large"
          title="Installation"
          open={!!showInstallationModel}
          primaryAction={{
            content: "Open Editor",
            onAction: function () {
              const activateAppId = APP_DEV
                ? "eb794bb4-e73e-4f01-b9c9-5ffb16022c00"
                : "b2ee1e4b-21c1-402e-a3b7-7dac9d3cff2a";
              const deepLink = `/themes/current/editor?context=apps&template=product&activateAppId=${activateAppId}/app-embed`;
              AppBridgeRedirect.dispatch(Redirect.Action.ADMIN_PATH, {
                path: deepLink,
                newContext: true,
              });
            },
          }}
          secondaryActions={[
            {
              content: "Watch Tutorial",
              onAction: () => {
                AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, {
                  url: "https://monsterapps.crisp.help/en/article/activate-deactivate-monster-cart-19okfn1/",
                  newContext: true,
                });
              },
            },
          ]}
          src={`${window.location.origin}/install.html`}
          onClose={() => setShowInstallationModel(false)}
        />

        
      </div>
    </Page>
  );
};

SettingsScreen.propTypes = {};

export default SettingsScreen;
